/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
// import { AnalyticsService } from './@core/utils/analytics.service';
//import { TranslationService } from './@core/service/translation.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor() {
    //this.translationService.languageAndDirectionSetup();
  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();
  }
}
